import { Component, OnInit, Input } from '@angular/core';
import { RegisterService } from 'src/app/services/register/register.service';
import { AlertListService } from '@xref/ngx';

@Component({
    selector: 'xlog-thank-you',
    templateUrl: './thank-you.component.pug',
    styleUrls: ['./thank-you.component.scss'],
    standalone: false
})
export class ThankYouComponent implements OnInit {
    @Input() email: string;

    constructor(
        private reg: RegisterService,
        private alertList: AlertListService
    ) {}

    ngOnInit() {}

    resendLinkSuccess = (data) => {
        this.alertList.append([{active: true, type: 'success', messageKey: 'pendingVerification.resendLinkSuccess', messageParameters: {email: this.email}}]);
    };

    resendLinkError = (err) => {
        this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.generic.error'}]);
    };

    resendLink() {
        this.reg.resendLinkByEmail(this.email).subscribe(
            this.resendLinkSuccess,
            this.resendLinkError
        );
    }
}
